// ======================================================================
// File Name       : ServiceGroupServiceContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as modalActions from '../../actions/ModalAction';
import * as serviceGroupActions from '../../actions/ServiceGroupAction';
import MessageSearch from '../../components/MessageSearch';
import ModalWrapper from '../../components/modal/ModalWrapper';
import ServiceGroupServiceList from '../../components/serviceGroup/ServiceGroupServiceList';
import { RETURN_MAX_NUM_1000 } from '../../constants';
import { REDIRECT_MODAL } from '../../constants/ServiceGroupConstants';
import { hideLoading, showLoading } from '../../utils/PageUtils';
import { Col } from 'react-bootstrap';
import { Button } from 'bootstrap';

class ServiceGroupServiceContainer extends Component {
  constructor() {
    super();
    this.state = {
      checkedService: [],
      checkedServiceOnPage: [],
      isAllowShowSearchMessage: false,
      isInit: false,
    };
    this.handleNextBtn = this.handleNextBtn.bind(this);
    this.handleBackBtn = this.handleBackBtn.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);
    this.handleServiceCheck = this.handleServiceCheck.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  componentDidMount() {
    const { serviceGroup } = this.props;
    !serviceGroup.searchResultService.searched && this.handleSearchBtn();
  }

  handleNextBtn() {
    const { dispatch, modalId } = this.props;
    dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].OK));
  }

  handleBackBtn() {
    const { dispatch, modalId } = this.props;
    dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].CANCEL));
  }

  handleSearchBtn() {
    const { dispatch, serviceGroup, authedUser } = this.props;
    dispatch(showLoading());
    this.setState({ checkedServiceOnPage: [], isAllowShowSearchMessage: false, isInit: false }, () => {
      const param = {
        searchInfo: {
          ...serviceGroup.searchConditionService,
          startPosition: 0,
          returnMaxNum: RETURN_MAX_NUM_1000,
          enterpriseCd: authedUser.enterpriseCd,
        },
      };
      dispatch(
        serviceGroupActions.getServiceGroupServiceList(param),
      ).then(() => {
        if (!this.state.isInit) {
          this.setState({ isAllowShowSearchMessage: true });
        }
        dispatch(hideLoading());
      });
    });
  }

  handleServiceCheck(event) {
    const { value, checked } = event.target;
    const checkedService = [...this.state.checkedService];
    const checkedServiceOnPage = [...this.state.checkedServiceOnPage];
    const pos = checkedService.indexOf(value);
    const pos2 = checkedServiceOnPage.indexOf(value);
    if (checked) {
      pos < 0 ? checkedService.unshift(value) : checkedService.splice(pos, 1);
      pos2 < 0 ? checkedServiceOnPage.unshift(value) : checkedServiceOnPage.splice(pos2, 1);

      // check addedList
      this.setState({ checkedService, checkedServiceOnPage }, () => {
        this.props.dispatch(serviceGroupActions.editingServiceGroupService({ addedList: checkedService }));
      });
    } else {
      // check remove
      if (pos >= 0) {
        checkedService.splice(pos, 1);
      }
      if (pos2 >= 0) {
        checkedServiceOnPage.splice(pos2, 1);
      }
      this.setState({
        checkedService,
        checkedServiceOnPage,
      }, () => {
        this.props.dispatch(serviceGroupActions.editingServiceGroupService({ removedServiceCd: value }));
      });
    }
  }

  handleCheckAll() {
    const { serviceGroup } = this.props;
    const searchResultService = serviceGroup.searchResultService.allServiceCds.reduce((acc, cur) => {
      if (!serviceGroup.editingServiceGroupService[cur]) {
        acc.push(cur);
      }
      return acc;
    }, []);

    const isCheckAll =
      Object.keys(serviceGroup.editingServiceGroupService).length !==
      serviceGroup.searchResultService.allServiceCds.length;
    if (isCheckAll) {
      const updatedCheckServiceOnPage = [...searchResultService];
      this.setState({
        checkedServiceOnPage: updatedCheckServiceOnPage,
        checkedService: searchResultService,
      }, () => {
        this.props.dispatch(serviceGroupActions.editingServiceGroupService({ addedList: updatedCheckServiceOnPage }));
      });
    } else {
      // uncheckAll
      this.setState(
        {
          checkedServiceOnPage: [],
          checkedService: [],
        },
        () => {
          this.props.dispatch(serviceGroupActions.editingServiceGroupService({ removedAll: true }));
        }
      );
    }
  }

  scrollToBottom() {
    const node = document.getElementById('scroll-table-service');
    node.scrollIntoView({ behavior: 'smooth' });
  }

  getModalOptions() {
    return {
      title: 'サービスグループに所属するサービスを選択してください',
      footerBtns: [
        { name: '戻る', onClick: this.handleBackBtn, variant: 'default' },
        { name: '次へ', onClick: this.handleNextBtn, variant: 'primary' },
      ],
    };
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  hideModal() {
    this.props.hideModal();
  }

  render() {
    const { serviceGroup } = this.props;
    const { editingServiceGroupService, searchResultService } = serviceGroup;
    return (
      <ModalWrapper {...this.getModalOptions()} dialogClassName="group-dialog" hideModal={this.hideModal}>
        <div className="max-width-950">
          <MessageSearch
            recordNum={searchResultService ? searchResultService.recordNum : 0}
            resultList={searchResultService ? searchResultService.allServiceCds : []}
            isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
            dismissMessage={this.dismissMessage}
          />
          <ServiceGroupServiceList
            searchResultService={searchResultService}
            editingServiceGroupService={editingServiceGroupService}
            checkedServiceOnPage={this.state.checkedServiceOnPage}
            handleCheckAll={this.handleCheckAll}
            handleServiceCheck={this.handleServiceCheck.bind(this)}
            handleBackBtn={this.handleBackBtn}
            handleNextBtn={this.handleNextBtn}
          />
        </div>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { serviceGroup, authority, authed: { authedUser } } = state;
  return {
    serviceGroup,
    authority: authority.authorityInfo,
    authedUser,
  };
};
export default connect(mapStateToProps)(ServiceGroupServiceContainer);
